export function getSlugRegionBySubRegion(slug: string, allSubRegions: any) {
  const regions = ['us', 'eu', 'kr', 'tw', 'cn', 'world'];
  if (regions.includes(slug)) {
    return slug;
  }
  for (const subRegion of allSubRegions) {
    if (subRegion.slug === slug) {
      return subRegion.regions[0].slug;
    }
  }
}
